import React from 'react';
import PropTypes from 'prop-types';
import { ContainedHeader } from 'web-ui-components/lib/layout/headers';

const HeaderComponent = ({ subline, isError, applyFor }) => {
  const { common, productNames } = subline;
return <ContainedHeader subline={isError ? 'Error' : `${common.headerInfo}${productNames[applyFor]}`} />
};

HeaderComponent.propTypes = {
  bankId: PropTypes.string.isRequired,
};

HeaderComponent.defaultProps = {
  bankId: 'CB',
};

export default HeaderComponent;
